export default {
  tabs: {
    gift_cards: 'Cadeaukaarten',
    settings: 'Instellingen',
  },
  gift_cards: {
    title: 'Cadeaukaarten',
    subtitle: 'Beheer alle cadeaukaarten voor uw restaurant',
    buttons: {
      create: 'Cadeaukaart aanmaken',
      redeem: 'Cadeaukaart inwisselen',
      check_balance: 'Saldo controleren',
    },
    search: {
      placeholder: 'Zoektekst invoeren',
    },
    columns: {
      code: 'Code',
      status: 'Status',
      balance: 'Saldo',
      value: 'Waarde',
      email: 'Koper',
      source: 'Bron',
      created_at: 'Aangemaakt',
    },
    statuses: {
      active: 'Actief',
      partially_redeemed: 'Gedeeltelijk ingewisseld',
      redeemed: 'Ingewisseld',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Cadeaukaartinstellingen',
      subtitle: 'Cadeaukaartopties configureren voor uw restaurant',
      availability: {
        title: 'Cadeaukaarten inschakelen',
        subtitle: 'Klanten toestaan cadeaukaarten te kopen en in te wisselen',
        buttons: {
          enable: 'Inschakelen',
          disable: 'Uitschakelen',
        },
      },
    },
    redemption_options: {
      title: 'Inwissel­opties',
      subtitle: 'Kies waar klanten cadeaukaarten kunnen inwisselen',
      redemption_mode: {
        title: 'Inwisselmodus',
        subtitle: 'Dit beïnvloedt de tekst op uw cadeaukaart-landingspagina',
        buttons: {
          online: 'Alleen online',
          online_and_store: 'Online & in de winkel',
        },
      },
    },
  },
  summary: {
    total_value: 'Totale waarde',
    total_active: 'Totaal actief',
    redeemed_this_month: 'Deze maand ingewisseld',
  },
};
